<template>
  <div class="content">
    <grid 
      label='Ap File Template'
      :model="getModel"
      name=""
      desc=""
      search
      :views='false'
      :resizing='false'
      layout="frame"
      :endpoint="api.$.FundingInvoiceAndApSetting.getAPFileTemplates"
      :actions='actions'
      @changeRow='editAPFileTemplates'
      @editRow='openEditAPFileTemplate($event)'
      :checkboxes='false'
      fit-columns
      footer
      ref="APFileTemplatesGrid">
        <span slot="additionalButtons">
        </span>
    </grid>
    <EditAPFileTemplate
      v-if='showEditAPFileTemplate'
      :model= "apFileTemplateModel"
      :showModal= "showEditAPFileTemplate"
      @close="showEditAPFileTemplate = false"
      @save='onSave'
    >

    </EditAPFileTemplate>
  </div>
</template>

<script>

import Grid from '@/components/Grid'
import Model from './APFileTemplatesModel'
import {edit} from '@/components/Grid/cells/actions'
import EditAPFileTemplate from './EditAPFileTemplate.vue'

export default {
  components: {
    Grid,
    EditAPFileTemplate
  },

  data() {
    return {
      Model,
      actions: [edit],
      showEditAPFileTemplate: false,
      apFileTemplateModel: {
        Name: '',
        Divisions: [],
        BusinessUnits: []
      }
    }
  },

  computed: {
    getModel() {
      return Model.get()
    }
  },

  created() {
  },

  methods: {
    editAPFileTemplates() {
    },
    async openEditAPFileTemplate(apFileTemplate) {
      let hasAPSettingsByBU = false
      await this.api.get(this.api.$.FundingInvoiceAndApSetting.hasAPSettingsByBU)
        .then(response => {
          hasAPSettingsByBU = response.data.Data
        })
      let divisions = []
      await this.api.get(this.api.$.FundingInvoiceAndApSetting.getSelectedAPTemplateDivisions, {
        params: {
          auditFileTemplateId: apFileTemplate.data && apFileTemplate.data.AuditFileTemplateId || 0
        }
      })
      .then(response => {
        divisions = response && response.data && response.data.Data
      })
      let businessUnits = []
      if (hasAPSettingsByBU) {
        await this.api.get(this.api.$.FundingInvoiceAndApSetting.getSelectedAPTemplateBusinessUnits, {
          params: {
            auditFileTemplateId: apFileTemplate.data && apFileTemplate.data.AuditFileTemplateId || 0
          }
        })
        .then(response => {
          businessUnits = response && response.data && response.data.Data
        })
      }

      this.apFileTemplateModel = {
        AuditFileTemplateId: apFileTemplate.data.AuditFileTemplateId,
        Name: apFileTemplate.data.Name,
        HasAPSettingsByBU: hasAPSettingsByBU,
        Divisions: divisions,
        BusinessUnits: businessUnits
      }

      this.showEditAPFileTemplate = true
    },
    refreshTable() {
      this.$refs.APFileTemplatesGrid.quickSearch()
      this.$refs.APFileTemplatesGrid.onSelectAll(false)
    },
    onSave() {
      this.showEditAPFileTemplate = false
      this.refreshTable()
    }
  }
}

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/_modules/FundingInvoiceAndAPSettings/APFileTemplates/index.vue